import { Component, OnInit } from '@angular/core';
import { PreLoginContent } from '@app/core/models';
import { PreLoginContentService } from '@app/core/services/pre-login-content.service';

@Component({
  selector: 'ecp-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
})
export class WelcomeComponent implements OnInit {
  contentLoading = true;
  content: PreLoginContent;
  constructor(private preLoginContentService: PreLoginContentService) {}

  ngOnInit(): void {
    this.loadContent();
  }

  loadContent(): void {
    this.preLoginContentService.getContent().subscribe(res => {
      this.contentLoading = false;
      this.content = res;
    });
  }
}
